import { FormattedMessage } from 'react-intl'
import { Box, styled } from '@mui/material'
import { Button, ButtonProps, Snackbar } from '@carto/meridian-ds/components'

const Footer = styled(Box, {
  shouldForwardProp: (prop) => !['withGutter', 'disabled'].includes(prop as string)
})<{ withGutter?: boolean; disabled?: boolean }>(({ withGutter, disabled, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),

  ...(withGutter && {
    height: theme.spacing(4),
    padding: theme.spacing(0, 0.5),
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: '1px solid transparent'
  }),

  ...(disabled && {
    backgroundColor: theme.palette.default.background
  })
}))

interface Props extends ButtonProps {
  labelIdButtonFooter?: string
  ariaLabelButtonFooter?: string
  disabledButtonFooter?: boolean
  withGutter?: boolean
  onClickFooter?: () => void
  showSnackbar?: boolean
  onCloseSnackbar?: () => void
}

export default function CodeAreaFooter({
  onClickFooter,
  labelIdButtonFooter,
  ariaLabelButtonFooter,
  disabledButtonFooter,
  withGutter = true,
  showSnackbar,
  onCloseSnackbar,
  disabled,
  ...props
}: Props) {
  if (!onClickFooter) return null

  return (
    <Footer withGutter={withGutter} disabled={disabled}>
      <Button
        variant="text"
        {...props}
        onClick={onClickFooter}
        aria-label={ariaLabelButtonFooter || 'save-form-button'}
        disabled={disabled || disabledButtonFooter}
      >
        <FormattedMessage id={labelIdButtonFooter || 'common.button.saveForm'} />
      </Button>
      <Snackbar open={showSnackbar} autoWidth closeable={false} autoHideDuration={4000} onClose={onCloseSnackbar}>
        <FormattedMessage id="common.notifications.changesSaved" />
      </Snackbar>
    </Footer>
  )
}
